export const mk = {
    common: {
        home: 'Почетна',
        search: 'Пребарај',
        guest: 'Гостин',
        logout: 'Одјави се',
        toggleTheme: 'Смени тема',
        toggleSidebar: 'Вклучи/исклучи странична лента',
        close: 'Затвори',
        more: 'Повеќе',
        saveChanges: 'Зачувај промени',
        cancel: 'Откажи',
        delete: 'Избриши',
        export: 'Извези',
        loading: 'Се вчитува...',
        activity: 'Активност',
        confirm: 'Потврди',
        noResultsFound: 'Нема пронајдени резултати.',
        justNow: 'токму сега',
        minutesAgo: 'пред {{count}} мин.',
        hoursAgo: 'пред {{count}} ч.',
        daysAgo: 'пред {{count}} д.',
        pagination: {
            previous: 'Претходна',
            next: 'Следна',
            page: 'Страница {{page}} од {{totalPages}}',
            summary: 'Страница {{page}} од {{totalPages}} · прикажани {{count}} од {{total}} ставки'
        }
    },
    notFound: {
        title: '404',
        heading: 'Страницата не е пронајдена',
        description: 'Страницата што ја бараш не постои или е преместена.',
        cta: 'Оди на Контролна табла'
    },
    routeError: {
        heading: 'Нешто тргна наопаку',
        description: 'Рутерот наиде на неочекувана грешка при вчитување на оваа страница.',
        cta: 'Назад на Контролна табла'
    },
    startup: {
        preparingSessionTitle: 'Ја подготвуваме твојата сесија',
        preparingSessionDescription: 'Ја проверуваме автентикацијата пред работниот простор да стане интерактивен.',
        preparingSessionStatus: 'Се проверува автентикацијата',
        loadingDataTitle: 'Се вчитуваат почетните податоци',
        loadingDataDescription: 'Се презема потребниот контекст за сметка и организација за апликацијата.',
        loadingDataStatus: 'Се вчитуваат почетните податоци',
        waitHint:
            'Овој екран останува видлив додека стартувањето не биде целосно подготвено, за заштитената навигација да не се појави прерано.',
        errorTitle: 'Не успеавме да го завршиме стартувањето',
        errorDescription:
            'Не успеа барање за стартување што може да се повтори. Обиди се повторно без целосно освежување на страницата.',
        errorFallback: 'Неочекувана грешка при стартување.',
        retry: 'Обиди се повторно',
        retryHint: 'Ако проблемот продолжи, провери ја конекцијата со backend и статусот на автентикацијата.'
    },
    appShell: {
        onboardingCheck: {
            failureTitle: 'Сѐ уште не можеме да го провериме onboarding',
            failureDescription:
                'Акциите во работниот простор остануваат паузирани додека повторно ја проверуваме onboarding состојбата на организацијата.',
            retry: 'Повтори onboarding проверка'
        }
    },
    dashboardWelcome: {
        badge: 'Прво добредојде на контролната табла',
        title: 'Внатре си. Еве го scaffold-от по checkout.',
        description:
            'Симулирана состојба на контролната табла само на frontend за нови работни простори. Вистинското креирање API клучеви, почетните шаблони и живиот конзолен излез доаѓаат подоцна.',
        continueAction: 'Продолжи во работниот простор',
        apiKeyTitle: 'Scaffold за API клуч',
        apiKeyDescription:
            'Placeholder картичка за првиот проектен клуч, опсези, копирање и метаподатоци за последна употреба.',
        primaryKey: 'Примарен клуч',
        createApiKey: 'Креирај API клуч',
        quickstartTitle: 'Scaffold за брз старт',
        quickstartDescription:
            'Стандардниот таб го следи build mode од onboarding. Snippet-ите засега се симулирани placeholder-и.',
        recommendedTemplateTitle: 'Препорачан шаблон',
        recommendedTemplateDescription:
            'Placeholder област за предлози за шаблони според onboarding целите и build mode.',
        starterPipelineTitle: 'Почетен content pipeline',
        starterPipelineDescription:
            'Тука ќе се прикажат предложени setup картички, почетни prompts и однапред пополнето поврзување на извори.',
        applyTemplate: 'Примени шаблон',
        consoleTitle: 'Конзола / област за одговор',
        consoleDescription: 'Placeholder за SDK одговори, траги од барања и првиот успешен излез.',
        consoleStatus: 'Статус: се чека жива backend интеграција…',
        consoleReady: 'Симулираниот панел за одговор е подготвен'
    },
    home: {
        title: 'Почетна',
        unlimited: 'Неограничено',
        apiUsage: '// API користење',
        publishJobsPerDay: 'Објавувачки задачи по ден',
        last7Days: 'Последни 7 дена',
        jobsOnDate: '{{count}} објавувачки задачи на {{date}}',
        noJobsLast7Days: 'Нема објавувачки задачи во последните 7 дена',
        usageUnavailable: 'Податоците за користење не се достапни',
        postsUsed: '@{{account}} · {{used}} / {{limit}} искористени објави',
        resetsOn: 'се ресетира {{date}}',
        noQuotaPeriod: 'Нема период на квота',
        gettingStarted: '// Започнете',
        recentJobs: '// Неодамнешни задачи',
        loadingRecentJobs: 'Се вчитуваат неодамнешните задачи…',
        recentJobsUnavailable: 'Неодамнешните задачи не се достапни.',
        noPublishingJobs: 'Сè уште нема објавувачки задачи.',
        untitledPost: 'Неименувана објава',
        activeKeyCount: '{{count}} активен API клуч',
        loadingDescription: 'Се вчитува прегледот на организацијата…',
        stats: {
            connectedAccounts: 'Поврзани сметки',
            sourcesInPlan: '{{count}} извори се вклучени во планот',
            postsLeft: 'Преостанати објави во периодот',
            postsAcrossAccounts: '{{count}} објави низ поврзаните сметки',
            scheduledJobs: 'Закажани задачи'
        },
        checklist: {
            createOrganization: 'Создајте организација',
            connectSocialAccount: 'Поврзете социјална сметка',
            socialAccountDetail: 'Instagram или X',
            createApiKey: 'Создајте API клуч',
            apiKeyScopes: 'publishing:read · publishing:publish',
            publishFirstPost: 'Објавете ја првата објава',
            publishEndpoint: 'POST /publishing/jobs'
        },
        actions: {
            createPost: 'Создај објава',
            start: 'Почни',
            viewAll: 'Види сè',
            viewApiDocs: 'Види API документација',
            createApiKey: 'Создај API клуч',
            connectAccount: 'Поврзи сметка',
            viewInsights: 'Види анализи',
            inviteMember: 'Покани член'
        },
        quickActions: '// Брзи акции',
        quickActionsTitle: 'Создавајте со вашата организација',
        quickActionsDescription: 'Почнете со алатките што веќе се поврзани со вашиот работен простор.',
        status: { published: 'Објавено', processing: 'Се обработува', scheduled: 'Закажано', other: 'Непознато' }
    },
    settings: {
        pageTitle: 'Поставки',
        pageDescription: 'Управувај со поставките и преференците на твојата организација.',
        general: 'Општо',
        notifications: 'Известувања',
        danger: 'Опасна зона',
        billing: {
            tab: 'Наплата',
            title: 'Наплата',
            description: 'Провери ја тековната состојба на наплатата за {{organizationName}}.',
            currentPlanEyebrow: '// тековен план',
            entitlementsEyebrow: '// привилегии',
            noOrganizationTitle: 'Нема избрана организација',
            noOrganizationDescription:
                'Избери или креирај организација за да ги видиш деталите за претплата и наплата.',
            portalFooter: 'Наплатата оди преку Stripe. Картичките и фактурите управувај ги во customer portal.',
            lifetimeBadge: 'Lifetime',
            lifetimeFooter:
                'Оваа организација е на lifetime план и не се наплатува преку Stripe, така што нема картички или фактури за управување. Контактирај invisibleapi за да го смениш планот.',
            cancelAtPeriodEndNotice:
                'Оваа претплата е поставена да се откаже на крајот од тековниот период на наплата.',
            manageBillingDisabledNoOrganization: 'Прво креирај или избери организација.',
            manageBillingDisabledNoCustomer: 'Оваа организација сè уште нема Stripe customer.',
            manageBillingDisabledLifetime: 'Lifetime планот не се наплатува преку Stripe, па нема customer portal.',
            priceAfterTrialValue: '{{price}}/{{interval}}',
            postsLimitValue: '{{count}} објави по поврзан профил за период.',
            noActivePlanTitle: 'Нема активен план',
            capabilitiesTitle: 'Можности',
            limitsTitle: 'Лимити',
            emptyBillingState: 'Сè уште нема достапна состојба на наплата за избраната организација.',
            emptyCapabilities: 'Не се вратени податоци за можности.',
            emptyLimits: 'Не се вратени податоци за лимити.',
            fields: {
                subscriptionStatus: 'Статус на претплата',
                billingInterval: 'Интервал на наплата',
                quantity: 'Извори (количина)',
                priceAfterTrial: 'Цена по пробниот период',
                trialEndsAt: 'Пробниот период завршува',
                currentPeriod: 'Тековен период',
                accessPeriod: 'Период на пристап',
                cancelAtPeriodEnd: 'Откажи на крај на периодот'
            },
            subscriptionStatuses: {
                active: 'Активна',
                trialing: 'Во пробен период',
                incomplete: 'Нецелосна',
                incomplete_expired: 'Нецелосна и истечена',
                past_due: 'Доцни со плаќање',
                canceled: 'Откажана',
                unpaid: 'Неплатена',
                paused: 'Паузирана'
            },
            billingIntervals: {
                monthly: 'Месечно',
                yearly: 'Годишно'
            },
            boolean: {
                yes: 'Да',
                no: 'Не'
            },
            errors: {
                generic: 'Податоците за наплата не можеа да се вчитаат.'
            },
            checkout: {
                loading: 'Се пренасочува…'
            },
            customerPortal: {
                open: 'Управувај со наплата',
                loading: 'Се отвора портал…'
            },
            returnState: {
                success: 'Checkout за наплата е завршен. Се освежува состојбата на наплата…',
                cancel: 'Checkout за наплата е откажан.',
                portalReturn: 'Се врати од порталот за наплата. Се освежува состојбата на наплата…'
            }
        },
        generalTitle: 'Општи поставки',
        generalDescription: 'Конфигурирај го името на работниот простор и основните преференци.',
        workspaceName: 'Име на организација',
        workspaceSlug: 'Slug на организација',
        timezone: 'Временска зона',
        settingsSaved: 'Поставките се зачувани',
        notificationsSaved: 'Преференците за известувања се зачувани',
        notificationsTitle: 'Преференци за известувања',
        notificationsDescription: 'Избери како и кога сакаш да бидеш известен.',
        emailNotifications: 'Известувања по е-пошта',
        emailNotificationsDescription: 'Примај е-пошта за активностите во работниот простор.',
        pushNotifications: 'Push известувања',
        pushNotificationsDescription: 'Добиј известувања во прелистувачот за важни настани.',
        weeklyDigest: 'Неделен преглед',
        weeklyDigestDescription: 'Примај неделен преглед на активноста во работниот простор.',
        dangerTitle: 'Опасна зона',
        dangerDescription: 'Неповратни акции што влијаат на твојата организација.',
        deleteWorkspace: 'Избриши организација',
        deleteWorkspaceDescription: 'Трајно избриши ја оваа организација и сите нејзини податоци.',
        deleteUnavailable: 'Оваа акција не е достапна во шаблонот.',
        exportData: 'Извези податоци',
        exportDataDescription: 'Преземи целосен извоз на податоците од работниот простор.',
        exportStarted: 'Извозот е започнат — ќе бидеш известен кога ќе биде подготвен.',
        savePreferences: 'Зачувај преференци'
    },
    accountDetails: {
        pageTitle: 'Детали за сметка',
        pageDescription: 'Управувај со профилните податоци и безбедносните акции на сметката.',
        loadErrorTitle: 'Деталите за сметката не можеа да се вчитаат',
        retry: 'Обиди се повторно',
        managedBadge: 'Централно управувано',
        readOnlyBadge: 'Само за читање',
        emptyValue: 'Не е поставено',
        fields: {
            firstName: 'Име',
            lastName: 'Презиме',
            username: 'Корисничко име',
            email: 'Е-пошта'
        },
        personalInfo: {
            title: 'Лични информации',
            description: 'Ажурирај ги профилните полиња што се уредливи за оваа сметка.',
            sourceHint: 'Корисничкото име и е-поштата доаѓаат од податоците за најава и не може да се уредуваат тука.',
            saving: 'Се зачувува...',
            reset: 'Ресетирај промени',
            saveSuccessToast: 'Деталите за сметката се зачувани.',
            validationErrorToast: 'Провери ги означените полиња и обиди се повторно.'
        },
        security: {
            title: 'Автентикација и безбедност',
            description:
                'Стартувај безбедносни текови на сметката преку backend акции. Администраторски пристап никогаш не стигнува до прелистувачот.',
            emailFlowBadge: 'Безбеден e-mail тек',
            password: {
                title: 'Основна автентикација',
                description:
                    'Испрати си e-mail за промена на лозинка и заврши ја промената преку безбедниот e-mail тек.',
                methodLabel: 'Метод за промена на лозинка',
                methodValue: 'Безбеден e-mail тек',
                action: 'Испрати e-mail за промена на лозинка',
                sending: 'Се испраќа e-mail...',
                successToast: 'Побаран е e-mail за промена на лозинка. Провери го сандачето.',
                successInline: 'E-mail е побаран. Провери го сандачето за текот за промена на лозинка.'
            },
            twoFactor: {
                title: 'Двофакторска автентикација',
                description: 'Испрати си e-mail за поставување и конфигурирај authenticator апликација преку тој тек.',
                methodLabel: 'Метод за поставување 2FA',
                methodValue: 'Безбеден e-mail тек',
                action: 'Испрати e-mail за поставување 2FA',
                sending: 'Се испраќа e-mail...',
                successToast: 'Побаран е e-mail за поставување 2FA. Провери го сандачето.',
                successInline: 'E-mail е побаран. Провери го сандачето за текот за поставување 2FA.'
            }
        }
    },
    sidebar: {
        appName: 'SaaS апликација',
        workspace: 'Организација',
        login: 'Најави се',
        logout: 'Одјави се',
        signedIn: 'Најавен',
        openSignIn: 'Отвори најава',
        account: 'Сметка',
        accountDetails: 'Детали за сметка',
        organizationMenu: 'Организации',
        organizations: 'Организации',
        currentOrganization: 'Тековна',
        noOrganization: 'Сѐ уште нема организација',
        language: 'Јазик',
        languageSelector: 'Избери јазик',
        languages: {
            en: 'Англиски',
            de: 'Германски',
            es: 'Шпански',
            fr: 'Француски',
            mk: 'Македонски',
            jp: 'Јапонски'
        }
    },
    nav: {
        home: 'Почетна',
        organizations: 'Организации',
        socialAccounts: 'Социјални сметки',
        members: 'Членови',
        invitations: 'Покани',
        publishing: 'Објавување',
        insights: 'Увиди',
        apiKeys: 'API клучеви',
        apiDocs: 'API документација',
        settings: 'Поставки',
        pricing: 'Цени',
        content: 'Содржина',
        audience: 'Публика',
        advancedQuery: 'Напредно барање',
        main: 'Главно'
    },
    publishing: {
        pageTitle: 'Објавување',
        pageDescription:
            'Прегледај ги задачите за објавување за {{organizationName}} и нивната најнова состојба на испорака.',
        emptyOrganizationDescription:
            'Избери или креирај организација за да почнеш да ги прегледуваш задачите за објавување.',
        empty: 'Сè уште нема задачи за објавување.',
        refreshAction: 'Превчитај задачи',
        refreshDescription: 'Повторно ги вчитува најновите задачи за објавување од серверот.',
        deliveryRecordsTitle: 'Што значат записите за испорака',
        deliveryRecordsDescription:
            'Секој запис за испорака претставува обид за испорака или резултат специфичен за платформата за избрана социјална сметка. Користи го за да видиш што се случило по цел.',
        scheduledFor: 'Закажано за {{value}}',
        pagination: {
            previous: 'Претходно',
            next: 'Следно',
            page: 'Страница {{page}}',
            summary: 'Страница {{page}} · прикажани {{count}} задачи (до {{perPage}} по страница)',
            summaryCompact: '{{count}} задачи · Страница {{page}} од {{totalPages}}'
        },
        emptyStateTitle: 'Сè уште нема задачи за објавување',
        createAction: 'Креирај објава',
        subscriptionInactiveDescription:
            'Новите објави и повторните обиди за неуспешни задачи се паузирани додека не се обнови претплатата на оваа организација.',
        previewAction: 'Преглед',
        previewPostAction: 'Преглед на објава',
        actionsMenuLabel: 'Отвори мени со акции',
        technicalDetailsAction: 'Технички детали',
        technicalDetailsTitle: 'Технички детали за задачата за објавување',
        technicalDetailsDescription:
            'Провери ги суровите податоци за објавување и деталите за испорака за оваа задача.',
        previewTitle: 'Преглед на задача за објавување',
        previewDescription: 'Провери ја најновата зачувана состојба за оваа задача за објавување.',
        previewLoading: 'Се вчитуваат детали за задачата за објавување…',
        instagram: {
            follow: 'Следи',
            mediaAlt: 'Instagram медиум за преглед',
            multiAsset: '{{count}} ставки',
            commentPlaceholder: 'Додај коментар…',
            justNow: 'токму сега'
        },
        noCaption: 'Нема внесен опис.',
        noMediaItems: 'На оваа задача за објавување не ѝ се прикачени медиумски ставки.',
        noDeliveries: 'Сè уште нема записи за испорака за оваа задача за објавување.',
        failureTitle: 'Детали за неуспехот',
        mediaItemsCount: '{{count}} медиумски ставки',
        deliveriesCount: '{{count}} записи за испорака',
        columns: {
            status: 'Статус',
            caption: 'Опис',
            targets: 'Испораки',
            createdAt: 'Креирано',
            publishedAt: 'Објавено',
            actions: 'Акции',
            actionsDescription: 'Го отвора прегледот и деталите за таа задача за објавување.'
        },
        fields: {
            status: 'Статус',
            createdAt: 'Креирано на',
            updatedAt: 'Ажурирано на',
            publishedAt: 'Објавено на',
            caption: 'Опис',
            firstComment: 'Прв коментар',
            requestedPublishAt: 'Закажано за',
            mediaItems: 'Медиумски ставки',
            captionHelp: 'Нека биде концизно и подготвено за платформата. Сè можеш да прегледаш пред испраќање.',
            firstCommentHelp: 'Опционално. Се објавува по главната содржина ако целната платформа го поддржува тоа.',
            mediaType: 'Тип на медиум',
            sourceUrl: 'Изворен URL',
            publicFetchUrl: 'Јавен URL за преземање',
            altText: 'Алтернативен текст',
            deliveries: 'Испораки',
            failureCode: 'Код за грешка',
            failureMessage: 'Порака за грешка'
        },
        status: {
            pending: 'На чекање',
            queued: 'Во редица',
            scheduled: 'Закажано',
            processing: 'Се обработува',
            published: 'Објавено',
            failed: 'Неуспешно',
            canceled: 'Откажано'
        }
    },

    publishingComposer: {
        pageTitle: 'Креирај објава',
        pageDescription:
            'Состави задача за објавување за {{organizationName}} и испрати ја во workflow-от за објавување.',
        backToList: 'Назад кон објавување',
        emptyOrganizationTitle: 'Нема избрана организација',
        emptyOrganizationDescription: 'Избери или креирај организација пред да составиш задача за објавување.',
        publishTimeHint: 'Избери дали оваа објава да излезе веднаш или во закажано локално време.',
        localTimezoneHint: 'Закажаното време ја користи твојата тековна локална временска зона.',
        connectAccountsAction: 'Отвори социјални сметки',
        platformHint:
            'Избери каде треба да се објави овој пост. Instagram и X можат да објавуваат кога има достапна активна поврзана сметка.',
        socialAccountHint: 'Избери ја поврзаната социјална сметка што треба да ја добие оваа објава.',
        socialAccountAutoSelected: 'Твојата единствена достапна поврзана сметка е автоматски предизбрана.',
        selectSocialAccountAction: 'Избери социјална сметка',
        selectedAccountsSummary: '{{count}} избрани сметки',
        selectedPlatformsLabel: 'Ќе се објави на',
        limits: {
            checking: 'Се проверува користењето за објавување…',
            remaining: 'Преостануваат {{count}} објави во овој период',
            exhausted: 'Лимитот за овој период е достигнат',
            exhaustedWithReset: 'Лимитот е достигнат. Се ресетира на {{resetAt}}',
            selectedExhaustedWarning: '{{account}} нема преостанат лимит за објавување. Се ресетира на {{resetAt}}.',
            selectedExhaustedWarningNoReset: '{{account}} нема преостанат лимит за објавување.',
            unavailable:
                'Користењето за објавување моментално не е достапно. Сè уште можеш да објавиш; backend лимитите ќе се проверат при испраќање.'
        },
        noEligibleAccountsTitle: 'Нема достапни сметки за објавување',
        noEligibleAccountsDescription: 'Поврзи Instagram или X сметка пред да креираш пост.',
        noHandle: 'Нема достапен јавен handle',
        selectedBadge: 'Избрано',
        notSelectedBadge: 'Неизбрано',
        comingSoon: 'Наскоро',
        additionalMediaItemsTitle: 'Дополнителни медиумски ставки',
        additionalMediaItemsDescription: 'Се задржува за carousel објави, X објавување и видеа.',
        mediaPublicUrlHint: 'Медиумот се испраќа како јавен URL.',
        noAccountsBadge: 'Нема сметка',
        mediaStepHint: 'Додади ги медиумските детали и описот за оваа објава.',
        textOnlyHint: 'Текстуалните X објави го испраќаат описот без медиумски ставки.',
        instagramNoImageHint: 'Без прикачена слика, оваа објава нема да биде објавена на Instagram.',
        mediaItemsTitle: 'Медиумски ставки',
        mediaItemsHint: 'Додај една или повеќе слики или видеа кога овој пост треба да содржи медиуми.',
        multiMediaBadge: '{{count}} медиумски ставки',
        addMediaAction: 'Додај медиуми во постот',
        removeMediaAction: 'Отстрани',
        mediaItemTitle: 'Медиумска ставка {{index}}',
        publicFetchUrlMirrorsSourceHint:
            'Backend-от бара sourceUrl. Ова поле повторно се користи и за sourceUrl и за publicFetchUrl при испраќање на објавата.',
        altTextPlaceholder: 'Пристапен опис за оваа медиумска ставка',
        captionPlaceholder: 'Напиши го описот на објавата…',
        submitAction: 'Објави пост',
        scheduleSubmitAction: 'Закажи објава',
        subscriptionInactiveDescription:
            'Обнови ја претплатата на оваа организација пред да креираш нова задача за објавување.',
        stepCompleteBadge: 'Завршено',
        submitting: 'Се објавува...',
        successToast: 'Задачата за објавување е креирана.',
        successToastScheduled: 'Задачата за објавување е закажана.',
        livePreviewTitle: 'Преглед во живо',
        livePreviewDescription: 'Прегледај ја објавата додека ја составуваш или отвори ја на цел екран.',
        fullscreenPreviewAction: 'Цел екран',
        selectDateAction: 'Избери датум',
        previewAccountPlaceholder: 'Избрана социјална сметка',
        previewHandlePlaceholder: '@account',
        previewMediaPlaceholder: 'Преглед на медиум',
        previewCaptionPlaceholder: 'Твојот опис ќе се појави тука додека пишуваш.',
        previewAdditionalMediaCount: '+{{count}} повеќе',
        previewScheduledBadge: 'Закажано',
        videoPreviewLabel: 'Видео преглед',
        twitterPreviewComingSoon: 'Twitter/X прегледот ја користи избраната X сметка и содржината на објавата.',
        postPublishingTitle: 'Објавување пост',
        stepFlowTitle: 'Чекор по чекор composer',
        stepFlowDescription:
            'Пополнувај го секој блок по ред. Подоцнежните блокови остануваат заклучени додека претходниот не биде подготвен.',
        publishModes: {
            now: 'Објави сега',
            nowDescription: 'Започни го workflow-от за објавување веднаш по испраќањето.',
            scheduled: 'Закажи за подоцна',
            scheduledDescription: 'Закажи ја оваа објава за иден датум и време.'
        },
        platforms: {
            instagram: 'Instagram',
            twitter: 'Twitter / X'
        },
        steps: {
            socialAccounts: 'Социјални сметки',
            targets: 'Цели',
            publishingTime: 'Време на објавување',
            postContent: 'Содржина на објавата'
        },
        fields: {
            platform: 'Целна платформа',
            socialAccount: 'Социјална сметка',
            mediaItems: 'Медиумски ставки',
            mediaUrl: 'URL на медиумот',
            captionHelp: 'Нека биде концизно и подготвено за платформата.',
            mediaType: 'Тип на медиум',
            sourceUrl: 'Изворен URL',
            publicFetchUrl: 'Јавен URL за преземање',
            altText: 'Алтернативен текст',
            caption: 'Опис',
            requestedPublishAt: 'Закажано за',
            scheduleDate: 'Датум',
            publishTime: 'Време на објавување',
            publishAtLocalTime: 'Објави во (локално време)',
            scheduleTime: 'Време'
        },
        placeholders: {
            primaryMediaUrl: 'https://cdn.yourapp.com/photo.jpg',
            additionalMediaUrl: 'https://cdn.example.com/post-image.jpg'
        },
        mediaTypes: {
            text: 'Само текст',
            image: 'Слика',
            video: 'Видео'
        },
        validation: {
            generic: 'Провери ја формата за објавување и исправи ги означените полиња.',
            socialAccountRequired: 'Избери социјална сметка пред да продолжиш.',
            platformRequired: 'Избери достапна целна платформа.',
            mediaItemRequired: 'Додај барем една медиумска ставка за избраните платформи.',
            mediaTypeInvalid: 'Објави само со текст се достапни само за X.',
            publishModeRequired: 'Избери опција за време на објавување пред да продолжиш.',
            captionRequired: 'Описот е задолжителен.',
            publicFetchUrlRequired: 'Јавниот URL за преземање е задолжителен.',
            publicFetchUrlInvalid: 'Јавниот URL за преземање мора да биде валиден URL.',
            xCarouselImagesOnly:
                'X карусел објавите поддржуваат само слики. Објави видео на X како објава со една медиумска ставка.',
            xCarouselImageCount: 'X карусел објавите поддржуваат најмногу {{count}} слики.',
            requestedPublishAtRequired: 'Избери закажан датум и време.',
            requestedPublishAtInvalid: 'Закажаниот датум и време мора да бидат валидни.',
            requestedPublishAtFuture: 'Закажаниот датум и време мора да бидат во иднина.'
        }
    },

    insights: {
        pageTitle: 'Instagram увиди',
        pageDescription: 'Избери сметка и временски опсег. Страницата се ажурира според овие два филтри.',
        emptyOrganizationDescription: 'Избери или креирај организација за да ги видиш Instagram увидите.',
        accountPickerLabel: 'Instagram сметка',
        accountPickerPlaceholder: 'Избери сметка',
        noInsightsAccounts:
            'Ниту една поврзана Instagram сметка сè уште не поддржува увиди. Поврзи професионална Instagram сметка за да започнеш.',
        noInsightsAccountsHelp:
            'Поврзи Instagram сметка со пристап до увиди за да отклучиш прегледни метрики, демографија на публика и распределби на содржина.',
        subscriptionInactiveTitle: 'Увидите се паузирани',
        subscriptionInactiveDescription:
            'Ажурирањата на Instagram увидите се паузирани додека претплатата на оваа организација е неактивна.',
        subscriptionInactiveHelp: 'Обнови ја претплатата за повторно да се повлекуваат свежи податоци за увиди.',
        connectAccountCta: 'Оди до социјални сметки',
        dateRangeLabel: 'Опсег на датуми',
        dateRange: {
            last7Days: 'Последни 7 дена',
            last14Days: 'Последни 14 дена',
            last30Days: 'Последни 30 дена'
        },
        overviewTitle: 'Преглед',
        tabs: {
            overview: 'Преглед',
            content: 'Распределба на содржина',
            trend: 'Тренд',
            breakdowns: 'Распределби',
            audience: 'Публика',
            advanced: 'Напредно барање'
        },
        currentViewLabel: 'Тековен приказ',
        currentViewTitle: 'Увиди за Instagram сметка',
        currentViewDescription:
            'Резиме картичките ги прикажуваат главните бројки. Користи ги табовите подолу за тренд, распределба, публика и истражување на сурово барање.',
        trendTitle: 'Досег низ време',
        trendTitleWithMetric: '{{metric}} низ време',
        trendDescription: 'Уникатни сметки достигнати по ден во избраниот опсег.',
        trendTracking: 'Се следи {{metric}} низ избраниот опсег.',
        chartValueLabel: 'Вредност',
        overviewSectionPrimaryLabel: '// примарно',
        overviewSectionEngagementLabel: '// ангажман',
        quickSegmentTitle: 'Брзо резиме на сегменти',
        quickSegmentDescription: 'Брз преглед на најсилната распределба на содржина за активната метрика.',
        topSegment: 'Водечки сегмент',
        topAudience: 'Водечка публика',
        rankTop: 'Водечки',
        primaryMetricBadge: 'Примарна',
        metricHelpLabel: 'Помош за {{metric}}',
        filtersBadge: 'Instagram увиди',
        filtersTitle: 'Фокусирај ја контролната табла',
        filtersDescription: 'Избери сметка и опсег на датуми. Страницата се ажурира според тие два филтри.',
        filtersAction: 'Филтри',
        filtersSheetTitle: 'Филтри за увиди',
        filtersSheetDescription: 'Прилагоди ја сметката и опсегот на датуми за контролната табла.',
        breakdownTitle: 'Распределби на метрики',
        breakdownDescription: 'Подели го вкупниот износ на метриката според поддржана димензија.',
        breakdownMetricLabel: 'Метрика',
        breakdownDimensionLabel: 'Распределба',
        breakdownColumns: {
            rank: 'Ранг',
            dimension: 'Димензија',
            value: 'Вредност',
            share: 'Удел'
        },
        breakdownTotal: 'Вкупно: {{value}}',
        audienceTitle: 'Демографија на публика',
        audienceDescription: 'Кој ја следи и комуницира со оваа сметка.',
        audienceMetricLabel: 'Публика',
        audienceMetrics: {
            follower_demographics: 'Следбеници',
            engaged_audience_demographics: 'Ангажирана публика'
        },
        audienceBreakdownLabel: 'Групирај по',
        audienceBreakdowns: {
            country: 'Земја',
            city: 'Град',
            age: 'Возраст',
            gender: 'Пол'
        },
        audienceTimeframeLabel: 'Временска рамка',
        audienceTimeframes: {
            this_week: 'Оваа недела',
            this_month: 'Овој месец'
        },
        advancedTitle: 'Напредно барање',
        advancedDescription: 'Испрати прилагодено барање до Instagram API за увиди и провери го суровиот одговор.',
        advancedExplorerDescription:
            'Истражувачот намерно е секундарен. Користи го за валидација на гранични метрики, неподдржани распределби и сурови API податоци.',
        advancedBadges: {
            rawApiQueryBuilder: 'Градител на сурово API барање',
            debugFirst: 'Прво дебагирање'
        },
        advancedMetricLabel: 'Метрики (разделени со запирка)',
        advancedMetricPlaceholder: 'reach',
        advancedPeriodLabel: 'Период',
        advancedMetricTypeLabel: 'Тип на метрика',
        advancedBreakdownLabel: 'Распределба',
        advancedBreakdownPlaceholder: 'media_product_type',
        advancedTimeframeLabel: 'Временска рамка',
        advancedSinceLabel: 'Од',
        advancedUntilLabel: 'До',
        advancedRun: 'Изврши барање',
        advancedNone: 'Нема',
        advancedPeriods: {
            day: 'Ден',
            week: 'Недела',
            days_28: '28 дена',
            lifetime: 'Цел период'
        },
        advancedMetricTypes: {
            total_value: 'Вкупна вредност',
            time_series: 'Временска серија'
        },
        rawResponseTitle: 'Суров одговор',
        metrics: {
            reach: 'Досег',
            accounts_engaged: 'Ангажирани сметки',
            total_interactions: 'Вкупни интеракции',
            likes: 'Допаѓања',
            comments: 'Коментари',
            shares: 'Споделувања',
            saves: 'Зачувувања',
            views: 'Прегледи',
            follows_and_unfollows: 'Следења и отследувања',
            profile_links_taps: 'Допири на линкови на профил'
        },
        metricDescriptions: {
            reach: 'Уникатни сметки што ја виделе содржината на сметката во избраниот опсег.',
            accounts_engaged: 'Уникатни сметки што комуницирале со содржината на сметката.',
            total_interactions: 'Комбинирани интеракции низ поддржаните engagement акции.',
            default: 'Општа метрика за увиди на ниво на сметка.'
        },
        breakdownDimensions: {
            REELS: 'Reels',
            POSTS: 'Објави',
            STORIES: 'Приказни',
            CAROUSEL_CONTAINER: 'Карусел објави',
            FOLLOWER: 'Следбеници',
            NON_FOLLOWER: 'Не-следбеници',
            FOLLOWERS: 'Следбеници',
            NON_FOLLOWERS: 'Не-следбеници',
            MEDIA_PRODUCT_TYPE: 'Тип на медиумски продукт',
            FOLLOW_TYPE: 'Тип на следење',
            CONTACT_BUTTON_TYPE: 'Тип на контакт копче',
            THIS_WEEK: 'Оваа недела',
            THIS_MONTH: 'Овој месец',
            UNKNOWN: 'Непознато',
            M: 'Машки',
            F: 'Женски',
            U: 'Непознато'
        },
        noData: 'Ова барање не врати податоци.',
        retry: 'Обиди се повторно',
        unknownError: 'Непозната грешка'
    },
    apiDocs: {
        pageTitle: 'API документација',
        pageDescription: 'Брз почеток, картички со ендпоинти и вградена API документација на едно место.',
        openFullDocumentation: 'Отвори целосна документација',
        subscriptionInactiveDescription:
            'API клучевите на организацијата се суспендирани додека пристапот до претплатата е неактивен, па автентицираните API барања за оваа организација ќе не успеваат сè додека не се обнови наплатата.',
        shell: {
            defaultDocsLocaleLabel: 'Стандардно',
            fallbackNotice:
                'Не постои посебен docs артефакт за frontend јазикот {{frontendLanguage}}, па страницата се префрли на {{docsLanguage}}.',
            organizationIdLabel: 'ID на активната организација',
            organizationIdDescription:
                'Користи го ова ID кога API endpoint бара path параметар за активната организација.',
            copyOrganizationId: 'Копирај ID на организација',
            organizationIdCopied: 'ID-то на организацијата е копирано.',
            noActiveOrganizationId: 'Нема избрана активна организација.',
            iframeRegionLabel: 'Контејнер за вградена API документација',
            iframeTitle: 'Вградена API документација за {{language}}',
            loadErrorTitle: 'Не можеше да се вчита docs manifest',
            loadErrorDescription: 'Docs manifest не можеше да се вчита: {{error}}',
            loadErrorFallback: 'Непозната грешка со docs manifest.',
            noDocsTitle: 'Не се пронајдени генерирани docs артефакти',
            noDocsDescription:
                'Docs manifest се вчита, но немаше достапни генерирани статички docs страници за вградување.'
        }
    },
    socialAccounts: {
        pageTitle: 'Социјални сметки',
        loadingDescription: 'Се вчитуваат социјалните сметки...',
        pageDescription: 'Управувај со поврзаните социјални сметки за твојата организација.',
        subscriptionInactiveDescription:
            'Додавањето или повторното поврзување на социјални профили е паузирано додека не се обнови претплатата на оваа организација.',
        sourceLimit: {
            title: 'Достигнат е лимитот за извори',
            description:
                'Оваа организација користи {{used}} од {{limit}} купени извори. Купи повеќе извори пред да поврзеш уште еден профил.',
            actionBlockedToast:
                'Достигнат е лимитот за извори. Купи повеќе извори пред да поврзеш уште еден социјален профил.',
            checking: 'Се проверува лимитот за извори…',
            unavailable:
                'Поврзувањето на нови профили е паузирано додека лимитот за извори не може повторно да се провери.',
            unavailableTitle: 'Лимитот за извори не можеше да се провери',
            unavailableRetry: 'Обиди се повторно',
            manageBillingAction: 'Управувај со наплата',
            ownerHint: 'Побарај од сопственик или администратор на организацијата да купи повеќе извори.'
        },
        searchPlaceholder: 'Пребарај социјални сметки',
        rowsPerPage: 'Редови по страница',
        empty: 'Нема пронајдени социјални сметки.',
        table: {
            title: 'Поврзани сметки',
            totalCount: '{{count}} вкупно сметки'
        },
        columns: {
            id: 'ID',
            accountName: 'Име на сметка',
            type: 'Тип',
            status: 'Статус',
            actions: 'Акции',
            actionsDescription: 'Го отвора прегледот или деталниот приказ за таа задача за објавување.'
        },
        actions: {
            copyId: 'Копирај ID',
            refresh: 'Поврзи повторно',
            reconnect: 'Поврзи повторно',
            delete: 'Исклучи'
        },
        types: {
            instagram: 'Instagram',
            x: 'X'
        },
        statuses: {
            active: 'Поврзана',
            degraded: 'Нарушена',
            reauthorization_required: 'Потребно е повторно поврзување',
            disconnected: 'Исклучена',
            error: 'Грешка'
        },
        pagination: {
            previous: 'Претходно',
            next: 'Следно',
            page: 'Страница {{page}} од {{totalPages}}',
            summary: 'Прикажани {{start}}-{{end}} од {{total}} сметки',
            summaryCompact_one: '{{count}} сметка · Страница {{page}} од {{totalPages}}',
            summaryCompact_other: '{{count}} сметки · Страница {{page}} од {{totalPages}}'
        },
        connectDialog: {
            trigger: 'Додај нова сметка',
            title: 'Поврзи социјална сметка',
            description: 'Избери социјален извор за поврзување.',
            liveBadge: 'Активно',
            comingSoonLabel: '// наскоро',
            trustCopy: 'Се авторизираш директно кај платформата. Никогаш не ја гледаме твојата лозинка.',
            platforms: {
                instagram: {
                    name: 'Instagram',
                    requirement: 'Business или Creator сметка поврзана со Facebook Page.'
                },
                x: {
                    name: 'X',
                    requirement: 'Која било X сметка.'
                }
            },
            comingSoonPlatforms: {
                tiktok: 'TikTok',
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube'
            },
            connectInstagram: 'Поврзи Instagram сметка',
            connectX: 'Поврзи X сметка'
        },
        deleteDialog: {
            title: 'Исклучи социјална сметка',
            description: 'Да се исклучи "{{accountName}}" од оваа организација?',
            success: 'Социјалната сметка е исклучена'
        },
        callback: {
            success: 'Социјалната сметка е успешно поврзана',
            error: 'Поврзувањето на социјалната сметка не успеа'
        },
        emptyOrganizationTitle: 'Не е избрана организација',
        emptyOrganizationDescription: 'Избери организација пред да управуваш со социјални сметки.',
        errors: {
            missingAuthorization: 'Не е пронајдена дозвола со која може да се управува за оваа социјална сметка.'
        },
        idCopied: 'ID-то на социјалната сметка е копирано'
    },
    organizationMembers: {
        pageTitle: 'Членови на организација',
        pageDescription: 'Управувај со членовите за {{organizationName}}.',
        fallbackOrganizationName: 'тековната организација',
        empty: 'Нема пронајдени членови за оваа организација.',
        count: '{{count}} членови · Страница {{page}} од {{totalPages}}',
        permissionHint:
            'Твојата тековна организациска улога дозволува преглед на оваа страница, но акциите за управување со членови се оневозможени за твоето ниво на дозволи.',
        genericMember: 'овој член',
        roleUpdated: 'Улогата на членот е ажурирана',
        memberRemoved: 'Членот е отстранет',
        removeAction: 'Отстрани член',
        confirmRemoveTitle: 'Отстрани член од организација',
        confirmRemoveDescription:
            'Да се отстрани {{memberName}} од оваа организација? Оваа акција не може да се врати преку UI.',
        columns: {
            member: 'Член',
            role: 'Улога',
            joinedAt: 'Датум на приклучување',
            actions: 'Акции',
            actionsDescription: 'Го отвора прегледот или деталниот приказ за таа задача за објавување.'
        },
        roles: {
            owner: 'Сопственик',
            admin: 'Администратор',
            member: 'Член',
            viewer: 'Прегледувач'
        },
        errors: {
            forbidden: 'Немаш дозвола да ја извршиш таа акција за член.',
            notFound: 'Тој член или таа организација не е пронајдена.',
            conflict: 'Таа промена ги прекршува правилата за членство во организацијата.',
            generic: 'Акцијата за член не успеа.'
        }
    },
    organizationInvitations: {
        pageTitle: 'Покани за организација',
        pageDescription: 'Управувај со поканите за {{organizationName}}.',
        fallbackOrganizationName: 'тековната организација',
        empty: 'Нема пронајдени покани за оваа организација.',
        emptyDashedTitle: 'Сè уште нема покани на чекање за оваа организација.',
        count: '{{count}} покани · Страница {{page}} од {{totalPages}}',
        permissionHint:
            'Твојата тековна организациска улога дозволува преглед на покани, но креирањето или повлекувањето покани е оневозможено за твоето ниво на дозволи.',
        inviteAction: 'Покани колега',
        dialogTitle: 'Покани колега',
        dialogDescription: 'Креирај покана за организација и копирај го еднократниот токен.',
        fields: {
            email: 'Е-пошта',
            role: 'Улога'
        },
        sendInvite: 'Испрати покана',
        inviting: 'Се креира покана...',
        invitationCreated: 'Поканата е креирана',
        invitationRevoked: 'Поканата е повлечена',
        revokeAction: 'Повлечи покана',
        tokenTitle: 'Токен за покана',
        tokenDescription: 'Овој токен се прикажува само еднаш. Копирај го сега ако треба да го споделиш или провериш.',
        copyToken: 'Копирај токен',
        tokenCopied: 'Токенот за покана е копиран',
        confirmRevokeTitle: 'Повлечи покана',
        confirmRevokeDescription: 'Да се повлече поканата за {{email}}?',
        columns: {
            email: 'Е-пошта',
            role: 'Улога',
            status: 'Статус',
            expiresAt: 'Истекува',
            createdAt: 'Креирана',
            actions: 'Акции',
            actionsDescription: 'Дејства за оваа покана, како нејзино повлекување.'
        },
        roles: {
            owner: 'Сопственик',
            admin: 'Администратор',
            member: 'Член',
            viewer: 'Прегледувач'
        },
        statuses: {
            pending: 'Во очекување',
            accepted: 'Прифатена',
            declined: 'Одбиена',
            revoked: 'Повлечена',
            expired: 'Истечена'
        },
        errors: {
            forbidden: 'Немаш дозвола да ја извршиш таа акција за покана.',
            notFound: 'Таа покана или таа организација не е пронајдена.',
            conflict: 'Таа акција за покана ги прекршува правилата за состојба на поканата.',
            generic: 'Акцијата за покана не успеа.'
        }
    },
    organizationInvitationAcceptance: {
        pageTitle: 'Покана за организација',
        pageDescription:
            'Прегледај ги деталите за поканата, најави се ако е потребно и избери дали ќе се придружиш на организацијата.',
        preparingAuth: 'Се подготвува автентикација…',
        resolving: 'Се обработува поканата...',
        resolvingDescription: 'Се проверува токенот за покана и се вчитуваат деталите за поканата.',
        invitationDetailsTitle: 'Детали за поканата',
        invitationDetailsDescription: 'Оваа покана може да ја прифати или одбие само најавената поканета сметка.',
        fields: {
            organization: 'Организација',
            role: 'Улога',
            email: 'Поканета е-пошта',
            status: 'Статус'
        },
        unknownOrganization: 'Непозната организација',
        loginRequiredTitle: 'Потребна е најава',
        loginRequired: 'Мора да се најавиш пред да можеш да одговориш на оваа покана.',
        loginAction: 'Најави се за да одговориш на поканата',
        registerAction: 'Создај сметка за да одговориш на поканата',
        acceptAction: 'Прифати покана',
        declineAction: 'Одбиј покана',
        wrongAccountTitle: 'Погрешна најавена сметка',
        wrongAccountDescription:
            'Оваа покана е за {{invitedEmail}}, но ти си најавен како {{currentEmail}}. Одјави се и најави се повторно со поканетата сметка.',
        accepting: 'Се прифаќа поканата...',
        acceptingDescription: 'Те приклучуваме во организацијата.',
        declining: 'Се одбива поканата...',
        decliningDescription: 'Ја одбиваме оваа покана.',
        success: 'Поканата е успешно прифатена.',
        declinedSuccess: 'Поканата е одбиена.',
        declinedSuccessDescription: 'Поканата е одбиена. Те носиме до твојата организација...',
        redirecting: 'Те пренасочуваме кон работниот простор на организацијата...',
        errorTitle: 'Поканата не можеше да се обработи',
        errors: {
            missingToken: 'Недостасува токенот за покана во URL.',
            unauthorized: 'Најави се и обиди се повторно со поканата.',
            invalidToken: 'Оваа покана е невалидна, истечена, одбиена, повлечена или веќе искористена.',
            generic: 'Акцијата за покана не успеа.'
        }
    },
    organizationApiKeys: {
        pageTitle: 'API клучеви на организација',
        pageDescription: 'Управувај со API клучевите за {{organizationName}}.',
        fallbackOrganizationName: 'тековната организација',
        empty: 'Нема пронајдени API клучеви за оваа организација.',
        permissionHint:
            'Твојата тековна организациска улога дозволува преглед на API клучеви, но креирањето или повлекувањето API клучеви е оневозможено за твоето ниво на дозволи.',
        subscriptionInactiveDescription:
            'Постојните API клучеви се суспендирани и нови API клучеви не може да се креираат додека не се обнови претплатата на оваа организација.',
        createAction: 'Креирај API клуч',
        dialogTitle: 'Креирај API клуч',
        dialogDescription: 'Креирај организациски API клуч и копирај го токенот сега — нема повторно да се прикаже.',
        fields: {
            name: 'Име',
            permissions: 'Дозволи'
        },
        permissionsDescription: 'Избери кои дозволи смее да ги користи овој API клуч.',
        permissionsPublishIncludesRead:
            'Пристапот за објавување вклучува и пристап за читање и автоматски ќе се додаде.',
        permissionsInsightsSeparate:
            'Дозволите за објавување веќе не вклучуваат пристап до insights. Постоечките клучеви само со дозволи за објавување не можат да читаат insights - додај ја дозволата за читање insights кога создаваш клуч што ја бара.',
        permissions: {
            publishing_read: {
                label: 'Читај податоци за објавување',
                description: 'Овозможува пристап само за читање до ресурси за објавување и објавена содржина.'
            },
            publishing_publish: {
                label: 'Објавувај медиуми',
                description: 'Овозможува креирање задачи за објавување и прикачување или објавување медиуми.'
            },
            insights_read: {
                label: 'Читај insights податоци',
                description: 'Овозможува пристап само за читање до Instagram insights податоци.'
            }
        },
        previewAction: 'Преглед на API клуч',
        previewExistingAction: 'Преглед на детали',
        backToEdit: 'Назад на уредување',
        previewTitle: 'Преглед на API клуч',
        previewDescription: 'Прегледај ги деталите и дозволите на API клучот пред креирање.',
        resultTitle: 'API клучот е креиран',
        resultDescription:
            'Копирај и зачувај го безбедно токенот за API клучот, па потоа прегледај ги зачуваните детали и дозволи.',
        previewSummaryTitle: 'Преглед на API клуч',
        previewSummaryDescription: 'Потврди го името на клучот и scope-овите пред да се генерира токенот.',
        previewPermissionsDescription: 'Ова се scope-овите што ќе бидат додадени на новиот API клуч.',
        previewExistingTitle: 'Детали за API клуч',
        previewExistingDescription: 'Прегледај ги зачуваните метаподатоци на API клучот и доделените дозволи.',
        previewExistingLoading: 'Се вчитуваат деталите за API клучот...',
        previewExistingEmpty: 'Не се вратени детали за овој API клуч.',
        previewExistingEndpointUnavailable:
            'Endpoint-от за детален преглед сѐ уште не е достапен, па овој модал ги прикажува метаподатоците веќе вчитани од листата на API клучеви.',
        previewExistingPermissionsDescription: 'Ова се scope-овите моментално доделени на овој API клуч.',
        previewExistingScopesLoaded: 'Дозволите се вчитани од endpoint-от за детали на API клучот.',
        previewExistingNoScopes: 'Не се вратени scope-ови за овој API клуч.',
        previewExistingTokenAvailable: 'Токенот на овој API клуч е достапен за прикажување во моментов.',
        previewExistingTokenUnavailable:
            'Овој API клуч може да се прегледа, но raw токенот не е достапен за прикажување.',
        previewExistingLimitation: 'Вредноста на токенот не е достапна за овој API клуч.',
        previewFields: {
            maskedKey: 'Маскиран клуч',
            fullKey: 'Целосен API клуч',
            revokedAt: 'Повлечен на'
        },
        createSubmit: 'Креирај клуч',
        creating: 'Се креира клуч...',
        apiKeyCreated: 'API клучот е креиран',
        apiKeyRevoked: 'API клучот е повлечен',
        revokeAction: 'Повлечи API клуч',
        tokenTitle: 'Токен за API клуч',
        tokenDescription:
            'Копирај го и зачувај го безбедно овој токен. Може да остане достапен во деталите за API клучот додека backend-поддршката го дозволува тоа.',
        copyToken: 'Копирај токен',
        tokenCopied: 'Токенот за API клуч е копиран',
        confirmRevokeTitle: 'Повлечи API клуч',
        confirmRevokeDescription: 'Да се повлече API клучот "{{apiKeyName}}"?',
        columns: {
            name: 'Име',
            status: 'Статус',
            createdAt: 'Креиран',
            actions: 'Акции',
            actionsDescription: 'Го отвора прегледот или деталниот приказ за таа задача за објавување.'
        },
        statuses: {
            active: 'Активен',
            revoked: 'Повлечен',
            suspended: 'Суспендиран'
        },
        errors: {
            forbidden: 'Немаш дозвола да ја извршиш таа акција за API клуч.',
            notFound: 'Тој API клуч или таа организација не е пронајдена.',
            conflict: 'Таа акција за API клуч ги прекршува правилата за состојба на API клучот.',
            generic: 'Акцијата за API клуч не успеа.'
        }
    },
    organizations: {
        loading: {
            title: 'Се вчитуваат организации',
            description: 'Се преземаат твоите организации и се избира активниот контекст.'
        },
        error: {
            title: 'Не можеа да се вчитаат организациите',
            description: 'Организацискиот shell не можеше да се иницијализира.',
            fallback: 'Непозната грешка со организации'
        },
        subscriptionInactive: {
            title: 'Претплатата е неактивна',
            actionBlockedToast: 'Обнови ја претплатата на оваа организација пред да ја користиш оваа акција.',
            manageBillingAction: 'Управувај со наплата',
            ownerHint: 'Побарај од сопственик на организацијата да ја обнови или реактивира наплатата.'
        },
        limitBanner: {
            cancelEndingTitle: 'Претплатата наскоро завршува',
            cancelEndingDescription:
                'Овој workspace ќе го изгуби пристапот на крајот од тековниот период на наплата. Обнови или ажурирај ја наплатата за да избегнеш прекин.',
            subscriptionInactiveDescription:
                'Пристапот до наплата за овој workspace е неактивен. Ажурирај ја претплатата за да го вратиш целосниот пристап.',
            trialEndingTitle: 'Пробниот период наскоро завршува',
            trialEndingDescription:
                'Пробниот период е при крај. Додај податоци за наплата или надгради сега за да избегнеш прекин.',
            manageBillingAction: 'Управувај со наплата',
            socialAccountsReachedTitle: 'Достигнат е лимитот за социјални сметки',
            socialAccountsReachedDescription:
                'Користиш {{used}} од {{limit}} слотови за поврзани социјални сметки. Надгради за да поврзеш повеќе сметки.',
            upgradeAction: 'Надгради план',
            socialAccountsWarningTitle: 'Се приближуваш до лимитот за социјални сметки',
            socialAccountsWarningDescription:
                'Користиш {{used}} од {{limit}} слотови за поврзани социјални сметки. Надгради пред да се блокираат нови поврзувања.',
            connectedAccountFallback: 'оваа поврзана сметка',
            publishingReachedTitle: 'Достигната е квотата за објавување',
            publishingReachedDescription:
                '{{accountName}} ги искористи сите {{limit}} објави за тековниот период на наплата. Надгради за да продолжиш со објавување.',
            publishingWarningTitle: 'Се приближуваш до квотата за објавување',
            publishingWarningDescription:
                '{{accountName}} има искористено {{currentUsage}} од {{limit}} објави за тековниот период на наплата. Надгради пред објавувањето да се блокира.'
        },
        fields: {
            name: 'Име на организација',
            slug: 'Slug',
            slugHelp: 'Опционално. Остави празно за автоматски да се генерира slug од името на организацијата.'
        },
        create: {
            cta: 'Креирај организација',
            title: 'Креирај организација',
            description: 'Креирај нова организација и веднаш префрли се на неа.',
            pageTitle: 'Нова организација',
            pageDescription: 'Креирај нова организација и веднаш почни да управуваш со неа.',
            pageIntro: 'Постави нова организација',
            pageHint:
                'По креирањето, новата организација автоматски станува активен контекст и ќе бидеш пренасочен назад во апликацијата.',
            sectionTitle: 'Креирај уште една организација',
            sectionDescription:
                'Креирај нова организација директно од страницата Organizations и веднаш направи ја активна.',
            hideSection: 'Сокриј форма',
            submit: 'Креирај',
            submitting: 'Се креира...',
            success: 'Организацијата е креирана',
            error: 'Креирањето на организацијата не успеа',
            conflictError: 'Веќе постои организација со тоа име или slug.',
            validationFallback: 'Поправи ги грешките во формата и обиди се повторно.'
        },
        switcher: {
            label: 'Организации',
            selectOrganization: 'Избери организација',
            loadMore: 'Вчитај уште организации ({{shown}}/{{total}})',
            loadError: 'Не можеа да се вчитаат организациите.',
            emptyTitle: 'Сѐ уште нема организации',
            emptyDescription:
                'Креирај ја твојата прва организација за да ги отклучиш страниците ограничени на организација.'
        },
        emptyState: {
            title: 'Креирај ја твојата прва организација',
            description:
                'Сѐ уште немаш организација. Креирај една за да го иницијализираш контекстот на работниот простор и да ги отклучиш страниците ограничени на организација.'
        },
        onboarding: {
            title: 'Организации',
            description:
                'Креирај ја твојата прва организација овде. Штом ќе имаш една, остатокот од апликацијата ќе биде нормално достапен.',
            createTitle: 'Креирај ја твојата прва организација',
            createDescription:
                'Започни овде за да го воспоставиш организацискиот контекст од кој зависи остатокот од продуктот.',
            workspaceSetupTitle: 'Заврши го поставувањето на организацијата',
            workspaceSetupDescription:
                'Сметките без организации сѐ уште можат да ги користат Organizations и Settings за да го завршиш поставувањето и да управуваш со твојот профил.',
            nextStepsTitle: 'Што следува',
            nextStepsDescription:
                'Штом ќе постои првата организација, апликацијата може да продолжи со нормалниот тек на работниот простор.',
            nextStepsCreate: 'Креирај ја организацијата што ќе стане твој стандарден контекст.',
            nextStepsInvite:
                'По креирањето, можеш да се вратиш тука за да поканиш колеги и да ја прошириш организацијата.',
            nextStepsUnlock:
                'Страниците ограничени на организација автоматски ќе станат достапни по креирањето на првата организација.'
        },
        pageShell: {
            title: 'Организации',
            description: 'Посебно место за организациски контекст, креирање и идни управувачки површини.',
            overview: {
                title: 'Организација',
                description:
                    'Прегледај ги твоите тековни организации и избери активен контекст за остатокот од апликацијата.',
                currentState: 'Активна организација'
            },
            metrics: {
                totalOrganizations: 'Вкупно организации',
                activeOrganization: 'Активна организација',
                activeRole: 'Активна улога',
                noneSelected: 'Не е избрано'
            },
            list: {
                count: '{{count}} организации',
                title: 'Твои организации',
                description: 'Погледни ги сите организации во кои членуваш и од тука смени го активниот контекст.',
                switchAction: 'Направи активна',
                membershipIdLabel: 'ID на членство: {{membershipId}}'
            },
            quickActions: {
                title: 'Брзи акции',
                description: 'Започни организациски текови од едно место.',
                hint: 'Оваа страница ќе стане главна дестинација за onboarding и управување со организации.'
            },
            tabs: {
                title: 'Секции на организација',
                description: 'Префрлај се помеѓу областите за управување на активната организација.',
                organizations: 'Организации',
                members: 'Членови',
                invitations: 'Покани',
                membersDescription: 'Управувај со членовите на активната организација.',
                invitationsDescription: 'Управувај со поканите на активната организација.'
            },
            membersPlaceholder: {
                title: 'Placeholder за секција со членови',
                description:
                    'Управувањето со членови ќе биде овде штом посветената страница Organizations го преземе тековниот flow за членови.'
            },
            invitationsPlaceholder: {
                title: 'Placeholder за секција со покани',
                description:
                    'Управувањето со покани ќе биде овде штом страницата Organizations го преземе тековниот flow за покани.'
            },
            routingNotice: 'Members и Invitations сега се под Organizations. API Keys засега останува одделно.'
        }
    },
    confirmDialog: {
        loading: 'Се вчитува...'
    },
    oauthConsent: {
        pageTitle: 'Авторизирај пристап',
        pageDescription: 'Прегледај го ова барање пред да дозволиш пристап до податоците на твојата организација.',
        clientRequestTitle: '{{clientName}} бара пристап',
        clientRequestDescription:
            'Со одобрување, оваа апликација ќе може да дејствува во твое име со дозволите наведени подолу.',
        scopesTitle: 'Побарани дозволи',
        scopesEmpty: 'Не се побарани конкретни дозволи.',
        scopes: {
            mcp: 'Целосен пристап до MCP',
            mcpDescription: 'Алатки за објавување и увиди преку MCP-гејтвејот.'
        },
        expiresAt: 'Ова барање истекува на {{date}}.',
        organizationTitle: 'Организација',
        organizationDescription: 'Избери до која организација може да пристапува оваа апликација.',
        organizationSingleDescription: 'Пристапот ќе биде доделен за оваа организација.',
        organizationsEmptyTitle: 'Нема достапна организација',
        organizationsEmptyDescription: 'Потребна ти е барем една организација пред да можеш да го одобриш ова барање.',
        approve: 'Одобри',
        deny: 'Одбиј',
        approving: 'Се одобрува...',
        denying: 'Се одбива...',
        redirecting: 'Пренасочување…',
        redirectsTo: 'Ќе бидеш пренасочен кон {{url}}.',
        continueToClient: 'Продолжи кон {{host}}',
        redirectBlocked: 'Одредиштето за пренасочување не е дозволено, па не беше извршено пренасочување.',
        errorTitle: 'Ова барање не може да се заврши',
        errors: {
            missingRequest: 'Референцата за барањето за согласност недостасува во URL-то.'
        }
    },

    onboardingFlow: {
        placeholderPreviewTitle: 'Преглед',
        placeholderPreviewDescription: 'Тука ќе се прикаже содржина за преглед специфична за чекорот.',
        stepPlaceholderDescription:
            'Имплементацијата ќе биде во следните PR-и за чекорите. Овој shell PR ги поврзува само рутите, layout-от, shared state и навигацијата.',
        stepBadge: 'Чекор {{step}}',
        saveFailed: 'Не можеше да се зачува напредокот на онбордингот. Обиди се повторно.',
        back: 'Назад',
        continue: 'Продолжи',
        next: 'Следно',
        pricePerMonth: '${{price}}/месечно',
        finish: 'Заврши',
        steps: {
            personalize: 'Персонализирај',
            connect: 'Поврзи',
            activate: 'Активирај',
            personalizeLabel: '01 · Персонализирај',
            connectLabel: '02 · Поврзи'
        },
        shell: {
            breadcrumb: 'Воведување',
            help: 'Отвори onboarding помош',
            counter: 'onboarding · {{current}} / {{total}}'
        },
        personalize: {
            title: 'Персонализирај',
            description:
                'Кажи ни што градиш за да го прилагодиме онбордингот и стандардните поставки на работниот простор.',
            badge: 'Чекор 01 · Персонализирај',
            heroTitle: 'Што градиш?',
            goalsTitle: 'Што сакаш прво да направиш?',
            goalsLabel: '// избери ги твоите цели',
            buildModeTitle: 'Како сакаш да градиш?',
            buildModeLabel: '// како ќе градиш',
            sourcesTitle: 'Колку извори очекуваш да поврзеш?',
            sourcesLabel: '// поврзани извори',
            sourcesDescription: 'Вклучени се 2 извори. Секој дополнителен извор чини $5/месечно.',
            sourcesHelper: 'Вклучени 2, потоа $5/месечно за секој следен.',
            templatesIncluded: '17 почетни шаблони се вклучени во секој план',
            decreaseSources: 'Намали број на извори',
            increaseSources: 'Зголеми број на извори',
            goalSingular: 'цел',
            goalPlural: 'цели',
            summary: '{{goalCount}} {{goalLabel}} · {{mode}} · {{sources}} извори · {{price}}/месечно',
            previewEmpty: 'Избери една или повеќе цели за да го видиш резимето на сетапот.',
            previewGoals: 'Избрани цели',
            previewBuildMode: 'Build mode',
            previewSources: 'Декларирани извори: {{count}}',
            previewPrice: 'Проценета цена: {{price}}',
            goals: {
                publish: {
                    label: 'Објави содржина',
                    description: 'Пушти содржина во канали со минимален glue code.',
                    cardTitle: 'Објавување и закажување',
                    cardDescription: 'Reels, карусели и stories — според твојот распоред',
                    endpointChip: 'POST /v1/publish/post',
                    recipeTitle: 'Планер за содржина',
                    recipeDescription:
                        'Стави reels и карусели во редица и автоматски објавувај ги од твоја апликација или база.'
                },
                comments: {
                    label: 'Модерирај коментари',
                    description: 'Автоматизирај одговори, triage и moderation flow.',
                    cardTitle: 'Коментари и спомнувања',
                    cardDescription: 'Повлечи разговори во моментот кога ќе се случат',
                    endpointChip: 'GET /v1/read/comments',
                    recipeTitle: 'Listener за спомнувања',
                    recipeDescription: 'Webhook се активира кога некој ќе те спомне — испрати го во Slack или CRM.'
                },
                analytics: {
                    label: 'Читај аналитика',
                    description: 'Повлечи account и content metrics во твојата апликација.',
                    cardTitle: 'Аналитика и увиди',
                    cardDescription: 'Досег, раст и најдобро време за објавување',
                    endpointChip: 'GET /v1/read/analytics',
                    recipeTitle: 'Аналитички dashboard',
                    recipeDescription:
                        'Метрики за досег, раст и најдобро време се пресметуваат за тебе и се праќаат во базата.'
                },
                ai: {
                    label: 'Пушти AI агенти',
                    description: 'Комбинирај content алатки со agent-driven workflow-и.',
                    cardTitle: 'AI одговори на коментари',
                    cardDescription: 'Подготвува одговори во твој тон — одобри или испрати автоматски',
                    endpointChip: 'MCP · алатки за одговор',
                    recipeTitle: 'Асистент за одговори на коментари',
                    recipeDescription:
                        'AI агент подготвува одговори во тонот на брендот; ти одобруваш или праќаш автоматски.'
                },
                ugc: {
                    label: 'Менаџирај UGC',
                    description: 'Собирај и насочувај creator content со approvals.',
                    cardTitle: 'Повторно објави UGC',
                    cardDescription: 'Најди означена содржина и објави ја повторно',
                    endpointChip: 'GET /v1/read/mentions',
                    recipeTitle: 'UGC repost алатка',
                    recipeDescription: 'Најди означени објави, побарај права и repost — целиот циклус автоматизиран.'
                },
                webhooks: {
                    label: 'Слушај webhooks',
                    description: 'Реагирај на account и publishing lifecycle настани.',
                    cardTitle: 'Webhooks и настани',
                    cardDescription: 'Потпишани webhooks за коментари, спомнувања и DMs',
                    endpointChip: 'POST /v1/webhooks',
                    recipeTitle: 'Event relay',
                    recipeDescription: 'Потпишани webhooks со повторни обиди за секој коментар, спомнување и DM.'
                }
            },
            buildModes: {
                code: {
                    label: 'Пишување код',
                    description: 'Сакам целосна API контрола и директна имплементација.',
                    summary: 'REST API и SDKs'
                },
                agent: {
                    label: 'Со AI агент',
                    description: 'Сакам агент да помогне со поврзување и автоматизација.',
                    summary: 'MCP за Claude и Cursor'
                },
                both: {
                    label: 'И двете',
                    description: 'Code-first контрола со помош од агент кога има смисла.',
                    summary: 'Код + агенти'
                }
            }
        },
        connect: {
            title: 'Поврзи Instagram',
            description:
                'Поврзи барем еден професионален Instagram профил сега, или прескокни и оди директно на пробниот checkout.',
            badge: 'Чекор 02 · Поврзи',
            headingTitle: 'Поврзи',
            headingEmphasis: 'Поврзи Instagram.',
            headingRest: 'Еден професионален профил сега, или прескокни директно на checkout.',
            requirementsLabel: '// предуслови',
            afterTrial: '/месечно по trial',
            trialBadge: '7-дневен trial',
            completedBadge: 'Checkout завршен',
            connectLaterBadge: 'Поврзи подоцна',
            priceStripBreakdown: '{{sources}} извори · 2 се вклучени во основата од $9',
            priceStripTerms: '7 дена trial · картичка на ден 0 · прва наплата на ден 8',
            skip: 'Прескокни засега — оди директно на пробниот checkout',
            trust: {
                secureTitle: 'Само безбеден OAuth',
                secureDescription:
                    'Никогаш не ја бараме твојата Instagram лозинка. Пристапот го одобруваш директно преку Meta.',
                setupTitle: 'Подготвено за објавување',
                setupDescription:
                    'Оваа конекција ја користиме за scheduling, publishing и analytics во твојата организација.',
                laterTitle: 'Може да додадеш повеќе подоцна',
                laterDescription: 'Поврзи еден профил сега, а подоцна додади уште кога тимот ќе биде спремен.'
            },
            requirementsTitle: 'Услови пред поврзување',
            requirements: {
                professional: 'Instagram профилот мора да биде професионален Business или Creator профил.',
                page: 'Тој Instagram профил мора веќе да биде поврзан со Facebook Page.'
            },
            connectionTitle: 'Instagram конекција',
            connectionDescription: 'Авторизирај го Instagram преку Meta — ќе бидеш пренасочен и вратен директно тука.',
            connectedCounter: 'поврзани: {{connected}} / {{sources}}',
            declaredSources: 'Декларирани извори: {{count}}',
            connected: 'Поврзани: {{count}}',
            syncedSources: 'Синхронизирани извори: {{count}}',
            errorTitle: 'Поврзувањето не успеа',
            errors: {
                callbackFailed: 'Поврзувањето на твојата Instagram сметка не успеа. Обиди се повторно.',
                popupBlocked: 'Instagram popup-прозорецот за најава беше блокиран. Овозможи popups и пробај повторно.',
                oauthDenied: 'Instagram авторизацијата беше откажана пред да се доделат дозволите.',
                personalAccount:
                    'Поддржани се само професионални Instagram сметки. Прво префрли ја сметката на Business или Creator.',
                missingPage:
                    'Оваа Instagram сметка мора да биде поврзана со Facebook Page пред да може да се користи тука.'
            },
            ctaConnect: 'Поврзи Instagram профил',
            ctaConnectAnother: 'Поврзи уште еден профил',
            ctaConnectShort: 'Поврзи профил',
            ctaConnected: 'Поврзано',
            ctaWaiting: 'Се чека Instagram…',
            previewTitle: 'Поврзани профили',
            previewDescription: 'Бројот на поврзани профили може автоматски да го зголеми бројот на извори.',
            previewSourcesNow: 'Извори сега: {{count}}',
            previewEmptyTitle: 'Сè уште нема поврзани Instagram профили',
            previewEmptyDescription: 'Поврзи профил лево за да видиш како се пополнува onboarding-от.',
            previewNextStep: 'Следен чекор',
            previewActivate: 'Активирај бесплатен trial',
            previewRequirementsLink: 'Провери Instagram услови',
            previewSyncedMessage: 'Shared state ги синхронизира изворите нагоре. Тековно декларирани извори: {{count}}',
            checkoutCanceled: 'Checkout-от е откажан. Твојата onboarding состојба сè уште е тука.',
            checkoutUnavailable:
                'Наплатата сè уште не е достапна — нема конфигуриран производ за наплата. Обиди се подоцна.',
            finalizingTitle: 'Ја финализираме твојата претплата',
            finalizingDescription: 'Чекаме Stripe да го потврди плаќањето. Ова обично трае неколку секунди.',
            checkoutTitle: 'Цена за пробниот период',
            checkoutDescription: 'Повеќе нема посебен Чекор 3 — checkout-от започнува директно одовде.',
            checkoutCta: 'Започни {{days}}-дневен пробен период',
            nextToDashboard: 'Оди во dashboard welcome state',
            previewConnectLater: 'Поврзи подоцна од dashboard ако треба.',
            previewTrialDetailsTitle: 'Детали за пробниот период',
            previewTrialDetails:
                'Ден 0: се собира картичката. Ден 8: прва наплата. Успехот пренасочува во dashboard welcome state.'
        },
        activate: {
            title: 'Активирај ја организацијата',
            description:
                'Стартувај го trial-от, потврди го бројот на извори и префрли го сетапот во dashboard welcome state.',
            trialActivatedTitle: 'Trial активиран',
            trialActivatedDescription:
                'Твојата организација е подготвена. Dashboard welcome state треба да ги преземе твоите цели, статусот на конекција и plan-от со {{count}} извори.',
            waitingCards: {
                connectionTitle: 'Instagram конекција',
                connectionDescription:
                    'Ако ја прескокна конекцијата, можеш да ја довршиш од dashboard welcome checklist.',
                workspaceTitle: 'Последни детали за организацијата',
                workspaceDescription:
                    'Твоите извори, цели и activation summary се пренесуваат во post-checkout welcome state.'
            },
            nextToDashboard: 'Оди на dashboard welcome state',
            startTrial: 'Стартувај {{days}}-дневен trial',
            cancelBannerTitle: 'Checkout откажан',
            cancelBannerDescription: 'Trial-от не беше стартуван. Сè што подеси тука останува зачувано.',
            badge: 'Чекор 3 · Активирај',
            heroTitle: 'Активирај го твојот {{days}}-дневен бесплатен trial',
            heroDescription:
                'Сè уште нема вистинско наплаќање. Ова е mock Stripe handoff што го зачувува onboarding state-от преку redirect, cancel и success.',
            postTrialPrice: 'Цена по trial',
            chargedStarting: 'Наплата од ден {{day}}',
            trust: {
                startToday: 'Почни го твојот {{days}}-дневен бесплатен trial денес',
                cardRequired: 'Потребна е картичка за да се активира организацијата',
                noCharge: 'Нема наплата до ден {{day}}'
            },
            priceBreakdownTitle: 'Разложување на цената',
            priceBreakdownDescription:
                'Прилагоди ги изворите пред да стартува trial-от. Цената останува врзана за заедничкиот helper.',
            sourcesTitle: 'Извори',
            sourcesDescription: 'Користи најмалку {{count}} извори за овој сетап.',
            baseLabel: 'Основа ({{count}} извори)',
            baseDetail: 'Вклучено пред add-ons',
            additionalLabel: 'Дополнителни извори',
            additionalDetailNone: 'Нема избрани дополнителни извори',
            additionalDetailSome: '{{count}} × ${{price}}',
            monthlyAfterTrialLabel: 'Месечно по trial-от',
            monthlyAfterTrialDetail: 'Точна цена по trial-от',
            breakdownIncluded: '{{count}} извори се вклучени во основата од ${{price}}',
            breakdownExpanded: '${{base}} основа + {{extraCount}} × ${{extraPrice}}',
            stripeHandoffTitle: 'Mock Stripe handoff',
            stripeHandoffDescription:
                'Користи ги mock состојбите подолу за да видиш redirect, cancel и success без вистинско наплаќање.',
            stripeReady: 'Подготвено за старт',
            stripeRedirecting: 'Пренасочување кон Stripe…',
            redirectTitle: 'Пренасочување кон Stripe Checkout',
            redirectDescription:
                'Во продукција, Stripe тука би ја земал картичката и би ја вратил апликацијата. Засега избери mock резултат.',
            simulateCancel: 'Симулирај cancel враќање',
            simulateSuccess: 'Симулирај успешен checkout',
            stripeCtaNote: 'CTA-то стартува mock Stripe session и го чува onboarding state-от низ враќањето.',
            recapTitle: 'Резиме на сетап',
            recapHeading: 'Подготвено за активирање',
            recapGoals: 'Избрани цели',
            recapInstagram: 'Instagram',
            recapSources: 'Извори',
            recapTrialDetails: 'Детали за trial',
            recapAfterCheckout: 'По checkout',
            recapNoneYet: 'Сè уште нема',
            recapConnected: '{{count}} поврзани',
            recapSkipped: 'Сè уште не — прескокнато засега',
            recapNotConnected: 'Сè уште не е поврзано',
            recapSourcesValue: '{{count}} извори · {{price}} по trial-от',
            recapTrialValue: '{{days}} дена бесплатно · потребна картичка · нема наплата до ден {{day}}',
            recapAfterCheckoutPending: 'Dashboard welcome state го добива ова резиме по успешен checkout.',
            recapAfterCheckoutComplete: 'Испрати го корисникот во dashboard welcome state со ова резиме.',
            expectedPriceTitle: 'Очекувана месечна цена по trial-от'
        }
    },
    pricing: {
        pageTitle: 'Цени',
        pageDescription: 'Јасни цени по извор, вклопени со остатокот од апликацијата.',
        eyebrow: 'Цени',
        calculatorTitle: 'Пресметај ја цената',
        calculatorDescription: 'Избери колку извори ти требаат и месечниот износ веднаш ќе се ажурира.',
        accountsLabel: 'Извори',
        accountsIncludedLabel: 'Извори вклучени во твојот план',
        minAccounts: '{{count}} извор',
        maxAccounts: '{{count}} извори',
        firstTierLabel: 'Први {{count}} извори',
        firstTierRate: '{{price}} за {{count}} извори',
        additionalAccountsLabel: 'Дополнителни извори',
        additionalAccountsRate: '{{price}} по дополнителен извор',
        monthlyTotalLabel: 'Месечен вкупно',
        monthlyOnlyHint: 'Проценка во живо, наплата месечно',
        customSolutionTitle: 'Ти треба прилагодено решение?',
        customSolutionDescription: 'Пиши ни ако ти треба цена за поголем обем или onboarding помош.',
        trialTitle: '7-дневен пробен период',
        trialDescription: 'Започни со 7-дневен пробен период, па продолжи со истиот месечен план базиран на количина.',
        checkoutCta: 'Започни пробен период во Stripe',
        requiresOrganization: 'Креирај или избери организација пред да започнеш checkout.',
        checkoutForOrganization: 'Checkout ќе започне за {{organizationName}} со избраната количина.',
        manageSubscriptionCta: 'Управувај претплата',
        alreadySubscribed: '{{organizationName}} веќе има активна претплата. Смени го бројот на извори од Поставки.',
        contactCta: 'Контактирај не',
        planTitle: 'Твојот план',
        planDescription:
            'Јасни месечни цени со {{count}} вклучени извори, а потоа фиксна цена за секој дополнителен извор.',
        month: 'месец',
        accountsSelected: 'Избрани {{count}} извори',
        planFirstTierLine: 'Први {{count}} извори вклучени',
        planTierCalculation: '{{price}} × {{count}}',
        includedLabel: 'Вклучено',
        primaryCta: 'Започни',
        monthlyOnlyDisclaimer: 'Само месечни цени. Без кредити и без претпоставки за годишна наплата.',
        features: {
            organizations: 'Организации, членови и покани',
            socialAccounts: 'Поврзани социјални сметки',
            publishing: 'Workflows за објавување',
            insights: 'Instagram увиди',
            apiKeys: 'Организациски API клучеви',
            customerSupport: 'Корисничка поддршка'
        }
    },
    apiErrors: {
        auth: {
            required: 'Потребна е автентикација.',
            invalidOrExpiredToken: 'Потребна е автентикација. Твојата сесија можеби е невалидна или истечена.'
        },
        validation: {
            invalidRequestBody: 'Барањето е невалидно. Провери ги испратените податоци и обиди се повторно.',
            required: 'Ова поле е задолжително.',
            emailInvalid: 'Внеси валидна е-пошта.',
            stringMaxLength: 'Оваа вредност е предолга.'
        },
        organizations: {
            invalidRequest: 'Барањето за организација е невалидно.',
            conflict: 'Веќе постои организација со тие податоци.',
            notFound: 'Организацијата не е пронајдена.',
            loadFailed: 'Организациите не можеа да се вчитаат.',
            createFailed: 'Организацијата не можеше да се креира.',
            validation: {
                nameMaxLength: 'Името на организацијата е предолго.',
                slugMaxLength: 'Slug-от на организацијата е предолг.',
                slugFormat: 'Slug-от на организацијата смее да содржи само мали букви, бројки и цртички.'
            }
        },
        onboarding: {
            updateForbidden: 'Само сопственици и администратори на организацијата можат да го ажурираат onboarding-от.',
            validation: {
                goalsRequiredBeforeConnect: 'Избери барем една onboarding цел пред да продолжиш кон поврзување.'
            }
        },
        billing: {
            invalidRequest: 'Барањето за наплата е невалидно.',
            manageForbidden: 'Немаш дозвола да управуваш со наплатата за оваа организација.',
            organizationNotFound: 'Организацијата не е пронајдена.',
            organizationOrProductNotFound: 'Организацијата или продуктот за наплата не е пронајден.',
            incompleteConfiguration: 'Наплатата сѐ уште не е целосно конфигурирана за овој checkout flow.',
            lifetimeSubscriptionActive:
                'Оваа организација е на lifetime план, па наплатата преку Stripe не е достапна. Контактирај invisibleapi за да го смениш планот.',
            integration: 'Провајдерот за наплата врати интеграциска грешка.',
            productsLoadFailed: 'Плановите за наплата не можеа да се вчитаат.',
            stateLoadFailed: 'Состојбата на наплатата за организацијата не можеше да се вчита.',
            checkoutFailed: 'Checkout сесијата не можеше да се креира.',
            customerPortalFailed: 'Customer portal не можеше да се отвори.',
            validation: {
                successUrlInvalid: 'Success URL за наплата е невалиден.',
                cancelUrlInvalid: 'Cancel URL за наплата е невалиден.',
                returnUrlInvalid: 'Return URL за наплата е невалиден.'
            }
        },
        userProfile: {
            loadFailed: 'Деталите за сметката не можеа да се вчитаат.',
            updateFailed: 'Деталите за сметката не можеа да се зачуваат.',
            actionEmailFailed: 'Безбедносниот e-mail за сметката не можеше да се побара.',
            accountServiceUnavailable: 'Сервисот за сметки моментално не можеше да го заврши барањето.',
            notFound: 'Профилот на сметката не е пронајден.',
            updateRejected: 'Сервисот за сметки го одби ажурирањето на деталите за сметката.',
            actionRejected: 'Сервисот за сметки го одби барањето за безбедносен e-mail.',
            validation: {
                readOnly: 'Ова поле е само за читање.',
                unsupported: 'Ова поле не е поддржано.'
            }
        },
        organizationInvitations: {
            listForbidden: 'Немаш дозвола да ги гледаш поканите за оваа организација.',
            createForbidden: 'Немаш дозвола да покануваш членови во оваа организација.',
            revokeForbidden: 'Немаш дозвола да повлекуваш покани за оваа организација.',
            createConflict:
                'Оваа покана не може да се креира затоа што ги прекршува правилата за организациски покани.',
            revokeConflict: 'Оваа покана не може да се повлече поради нејзината тековна состојба.',
            notFound: 'Организацијата или поканата не е пронајдена.',
            invalidToken: 'Оваа покана е невалидна, истечена, повлечена или веќе искористена.',
            actionFailed: 'Акцијата за покана не можеше да се заврши.'
        },
        organizationMembers: {
            listForbidden: 'Немаш дозвола да ги гледаш членовите на оваа организација.',
            removeForbidden: 'Немаш дозвола да го отстраниш овој член.',
            removeConflict:
                'Овој член не може да се отстрани затоа што ги прекршува правилата за членство во организацијата.',
            updateForbidden: 'Немаш дозвола да го ажурираш овој член.',
            updateConflict: 'Таа промена на улога ги прекршува правилата за членство во организацијата.',
            actionFailed: 'Акцијата за член не можеше да се заврши.',
            validation: {
                roleInvalid: 'Избраната организациска улога е невалидна.'
            }
        },
        organizationApiKeys: {
            listForbidden: 'Немаш дозвола да ги гледаш API клучевите на оваа организација.',
            manageForbidden: 'Немаш дозвола да управуваш со API клучевите за оваа организација.',
            notFound: 'Организацијата или API клучот не е пронајден.',
            createConflict:
                'Овој API клуч не може да се креира затоа што ги прекршува правилата за организациски API клучеви.',
            revokeConflict: 'Овој API клуч не може да се повлече поради неговата тековна состојба.',
            actionFailed: 'Акцијата за API клуч не можеше да се заврши.',
            validation: {
                nameMaxLength: 'Името на API клучот е предолго.'
            }
        },
        socialAccounts: {
            listFailed: 'Социјалните сметки не можеа да се вчитаат.',
            connectFailed: 'Не можеше да се започне поврзувањето на социјалната сметка.',
            reconnectFailed: 'Не можеше да се започне текот за повторно поврзување на социјалната сметка.',
            disconnectFailed: 'Социјалната сметка не можеше да се исклучи.',
            forbidden: 'Немаш дозвола да управуваш со социјалните сметки за оваа организација.',
            notFound: 'Организацијата или социјалната сметка не е пронајдена.',
            conflict: 'Оваа акција за социјална сметка не можеше да се заврши поради нејзината тековна состојба.'
        },
        publishing: {
            listFailed: 'Задачите за објавување не можеа да се вчитаат.',
            detailFailed: 'Деталите за задачата за објавување не можеа да се вчитаат.',
            createFailed: 'Задачата за објавување не можеше да се креира.',
            paidPlanLimitExceeded: 'Достигнат е лимит за објавување од платениот план.',
            paidPlanLimitExceededForAccount: 'Достигнат е лимитот за објавување за {{account}}.',
            paidPlanLimitExceededUnknownAccount: 'избраната сметка',
            paidPlanLimitExceededUsageDetails:
                'Тековна искористеност: {{currentUsage}}/{{limit}}. Активни резервации: {{activeReservations}}. Побарани објави: {{requestedCount}}.',
            paidPlanLimitExceededResetDetails: 'Обиди се повторно по {{resetAt}}.',
            forbidden: 'Немаш дозвола да управуваш со објавувањето за оваа организација.',
            notFound: 'Организацијата или задачата за објавување не е пронајдена.',
            conflict: 'Ова барање за објавување не можеше да се заврши поради тековните ограничувања за објавување.',
            validation: {
                mediaUrlUnreachable:
                    'Не може да се пристапи до URL-то на медиумот. Наведете јавно достапен директен линк до медиумска датотека.',
                mediaUrlHttpError: 'URL-то на медиумот врати грешка наместо да испорача медиумска датотека.',
                mediaUrlNotImage:
                    'Ова URL не води до датотека со слика. Ставете директен линк до слика (на пр. .jpg URL), а не до веб-страница.',
                mediaUrlNotVideo:
                    'Ова URL не води до видео датотека. Ставете директен линк до видео (на пр. .mp4 URL), а не до веб-страница.'
            }
        },
        oauthConsent: {
            loadFailed: 'Барањето за согласност не можеше да се вчита.',
            approveFailed: 'Барањето за согласност не можеше да се одобри.',
            denyFailed: 'Барањето за согласност не можеше да се одбие.',
            invalidRequest: 'Барањето за согласност е невалидно.',
            forbidden: 'Немаш дозвола да го одобриш ова барање за избраната организација.',
            notFound: 'Ова барање за согласност е непознато, истечено или веќе обработено.'
        },
        insights: {
            loadFailed: 'Увидите не можеа да се вчитаат.',
            invalidQuery: 'Барањето за увиди е невалидно. Провери ја комбинацијата на метрика, период и параметри.',
            forbidden: 'Немаш дозвола да ги гледаш увидите на оваа организација.',
            notFound: 'Организацијата или социјалниот профил не се пронајдени.',
            notReadable: 'Овој профил моментално не може да дава увиди. Поврзи го повторно со дозволата за увиди.',
            providerRejected:
                'Instagram го одби ова барање за увиди. Бараната комбинација на метрики можеби не е поддржана за овој профил.'
        }
    },
    validation: {}
} as const;
